module.exports = __webpack_public_path__ + "static/media/icon-services-car.afdf219b.png";